/*
 *
 * CheckRefundableTransactionModal
 *
 * @version 1.0.0
 * @author Patrizia Petrera
 * @since 02-Jul-2025
*/
import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  titleModalNotReversible: (
    <PortalMessage
      id='t.app.transactions.transactionDetails.titleModalNotReversible'
      defaultMessage='Non sei abilitato a stornare'
    />
  ),
  descriptionModalNotReversible: (
    <PortalMessage
      id='t.app.transactions.transactionDetails.descriptionModalNotReversible'
      defaultMessage='Per essere abilitato a stornare le transazioni sui punti vendita Intesa Sanpaolo, <b>contatta il tuo Amministratore.</b>'
    />
  ),
  labelPrimaryButtonModalNotReversible: (
    <PortalMessage
      id='t.app.okUnderstood'
      defaultMessage='Ok, ho capito'
    />
  ),
  titleModalNotReversibleMixed: (
    <PortalMessage
      id='t.app.ttl.refound.unavailable.cf_not_isp.title'
      defaultMessage='Storno non attivo sui punti vendita Intesa Sanpaolo'
    />
  ),
  descriptionModalNotReversibleMixed: (
    <PortalMessage
      id='t.app.transactions.transactionDetails.descriptionModalNotReversibleMixed'
      defaultMessage='<b>Contatta la Filiale Digitale di Intesa Sanpaolo </b>al <b>800 303 303 </b> dall’Italia (oppure +39 011 8019 200 dall’estero) per verificare la tua posizione.'
    />
  ),
  labelSecondaryButtonModalNotReversibleMixed: (
    <PortalMessage
      id='t.app.support.callUs.cta'
      defaultMessage='Chiama'
    />
  )
}

export default formattedMessage
